<influencer-module-container [title]="'INFLUENCER.insight.interaction_rate_development.title' | translate"
    [tooltip]="'INFLUENCER.insight.interaction_rate_development.tooltip' | translate"
    [hasNoData]="hasNoData"
    [isFetchingData]="isFetchingData"
    [placeholderWidth]="301"
    [height]="'335px'">

    <div class="chart-area">
        <achoo-line-chart *ngIf="!hasNoData && !isFetchingData" [chartData]="data"
            [legendEnabled]="false"
            [xAxisDateTimeLabelFormat]="'%m/%y'"
            [useDefaultPlaceholder]="false"
            [spacingBottom]="null"
            [smYAxisFontSize]="'1rem'"
            [yAxisValueMode]="'percentage'"
            [areaFillColor]="areaFillColor"
            [axisFontFamily]="axisFontFamily"
            [overridenTooltipConfig]="overridenTooltipConfig">
        </achoo-line-chart>

        <achoo-line-chart *ngIf="hasNoData || isFetchingData" [chartData]="placeholderData"
            [legendEnabled]="false"
            [xAxisDateTimeLabelFormat]="'%m/%y'"
            [useDefaultPlaceholder]="false"
            [spacingBottom]="null"
            [smYAxisFontSize]="'1rem'"
            [yAxisValueMode]="'percentage'"
            [axisFontFamily]="axisFontFamily">
        </achoo-line-chart>
    </div>

</influencer-module-container>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/interaction-rate-development/interaction-rate-development.component.html